export function showProgress(label: string): void {
  const overlay = document.getElementById('progress-overlay') as HTMLDivElement;
  const labelEl = document.getElementById('progress-label') as HTMLDivElement;
  const bar = document.getElementById('progress-bar') as HTMLProgressElement;
  labelEl.textContent = label;
  // Indeterminate (animated) until the task reports real progress; a bar stuck at 0 looked frozen.
  bar.removeAttribute('value');
  overlay.hidden = false;
}

export function updateProgress(done: number, total: number): void {
  const bar = document.getElementById('progress-bar') as HTMLProgressElement;
  bar.max = Math.max(total, 1);
  bar.value = done;
}

export function hideProgress(): void {
  const overlay = document.getElementById('progress-overlay') as HTMLDivElement;
  overlay.hidden = true;
}

export async function withProgress<T>(label: string, fn: (onProgress: (done: number, total: number) => void) => Promise<T>): Promise<T> {
  showProgress(label);
  try {
    return await fn(updateProgress);
  } finally {
    hideProgress();
  }
}
